export { default as HomeeDeliveryPage } from "./View";